import { Dispatch, SetStateAction } from 'react'
import TextField from '@mui/material/TextField'
import { IIncidentReportFormData } from '../IncidentReportModal'
import styles from '../styles.module.css'

interface IRootCauseTabProps {
  formData: IIncidentReportFormData
  setFormData: Dispatch<SetStateAction<IIncidentReportFormData>>
}

function RootCauseTab({ formData, setFormData }: IRootCauseTabProps) {
  function handleChange(field: keyof IIncidentReportFormData, value: any) {
    setFormData((prev) => ({ ...prev, [field]: value }))
  }

  return (
    <div className={styles.formContainer}>
      <TextField
        label='Root Cause Analysis'
        value={formData.rootCauseAnalysis}
        onChange={(e) => handleChange('rootCauseAnalysis', e.target.value)}
        multiline
        rows={12}
        fullWidth
      />
    </div>
  )
}

export default RootCauseTab
